// eslint-disable-next-line deprecate/import
import cloneDeep from 'lodash-es/cloneDeep';

// See also structured-clone.d.ts and .eslintrc-zero-errors.js
if (!window.structuredClone) {
  window.structuredClone = cloneDeep;
}
